<template>
  <div>
    <span>
      <button
        v-on:click="cariEkstre()"
        style="border: none; background: none; margin-right: 5px"
      >
        <box-icon
          style="float: right"
          name="search-alt-2"
          animation="tada-hover"
          color="#7367F0"
          class="text-body align-middle mr-25"
        ></box-icon>
      </button>
    </span>
    <FinansalRaporAylikDetay ref="finansalraporref" />
  </div>
</template>
<script>
import Store from "../../../../store/store";
import state from "../../../../store/state";
import "boxicons";
import FinansalRaporAylikDetay from "./FinansalRaporAylikDetay.vue";

import router from "../../../../router";

import { BDropdown, BDropdownItem } from "bootstrap-vue";
export default {
  components: {
    BDropdown,
    BDropdownItem,
    FinansalRaporAylikDetay,
  },
  methods: {
    cariEkstre() {
      this.$refs.finansalraporref.rpAcikFaturalarDetay(this.params.data);
    },
  },
};
</script>